import React from 'react';

import { ComboBox } from '../../../../../../shared/components/form-components';
import {
  useSelector,
  SelectorSettings,
  ParentSelectorSettings,
} from './hooks/useSelector';

type SelectorProps = {
  selectorSettings: SelectorSettings;
  parentSelectorSettings?: ParentSelectorSettings;
  reportType: string;
};

const Selector = ({
  selectorSettings,
  parentSelectorSettings,
  reportType,
}: SelectorProps) => {
  const { control, options, label, parameterKey, rules, isShowSelector } = useSelector({
    selectorSettings,
    parentSelectorSettings,
    reportType,
  });

  if (!isShowSelector) {
    return null;
  }

  return (
    <ComboBox
      control={control}
      name={parameterKey}
      label={label}
      options={options}
      rules={rules}
      valueKey="id"
    />
  );
};

export { Selector };
